import { cancelExpenseApi, getPaymentTransactionListApi } from "_services/accountingServices/accountingServices";
import { CustomPagination, CustomToolTip } from "components";
import BootstrapTable from "components/BootstrapTable";
import { constant } from 'constants/constant'
import { UserContext } from "context";
import { AddExpensesModal, ConfirmModalFor } from "modals";
import { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaRegTrashCan } from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";
import StorageService from "utils/StorageServices";

const GenExpListTab = ({ itemsPerPage, offset, onPageChange, search, dateRange, openExpenseModal, onExpenseModalClose, activeTab, refreshTrigger }) => {

    const { masterData } = useContext(UserContext);
    const navigate = useNavigate();
    const [paymentTransactionList, setPaymentTransactionList] = useState([]);
    const [totalRecord, setTotalRecord] = useState(0);
    const [showExpModal, setShowExpModal] = useState(false);
    const [cancelLoading, setCancelading] = useState(false)
    const [cancleExpenseOpen, setCancelExpenseOpen] = useState(false)

    useEffect(() => {
        if (openExpenseModal) setShowExpModal(true);
    }, [openExpenseModal]);


    const handleCloseModal = () => {
        setShowExpModal(false);
        onExpenseModalClose(); // parent ka state reset
    };


    const columns = [
        { header: "", accessor: "serial" },
        { header: "# Number", accessor: "number" },
        { header: "Voucher Date", accessor: "voucher_date" },
        { header: "Firm name", accessor: "firm_name" },
        { header: "Vendor", accessor: "vendor" },
        { header: "Total Amount", accessor: "total_amt" },
        { header: "Balance", accessor: "balance" },
        { header: "Under Approval", accessor: "under_approval" },
        { header: "Status", accessor: "status" },
        { header: "Tags", accessor: "tags" },
        // { header: "Action", accessor: "action" },
    ];

    const fetchPaymentTransactions = async () => {
        try {
            const payload = {
                company_id: StorageService.getCompanyId(),
                firm_id: StorageService.getFirmId(),
                limit: itemsPerPage,
                offset,
                search,
                ...(dateRange?.start_date && { start_date: dateRange.start_date, end_date: dateRange.end_date }),
            };
            const res = await getPaymentTransactionListApi(payload);
            if (res?.responseCode === 200) {
                setPaymentTransactionList(res?.data?.list);
                setTotalRecord(res?.data?.total_record);
            }
        } catch (error) {
            console.error("Error fetching payment transactions:", error);
        }
    };

    useEffect(() => {
        fetchPaymentTransactions();
    }, [offset, search, dateRange?.start_date, dateRange?.end_date, refreshTrigger])

    const getStatusStyle = (status) => {
        const map = {
            Completed: { label: "Completed", color: "#22C55E" },
            Cancelled: { label: "Cancelled", color: "#EF4444" },
            Pending: { label: "Pending", color: "#F97316" },
        };
        return map[status] || { label: status || "-", color: "#6B7280" };
    };

    const handleRowClick = (item) => {
        navigate(
            `/accounting/ptransactions/${item._id}` +
            `?offset=${offset}&total_record=${totalRecord}&type=1` +
            `&sequence_no=${item.original?.sequence_no}` +
            `&status=${item.original?.status}` +
            `&invoice=${item.original?.invoice}` +
            `&tab=${activeTab}`
        );
    };

    const callBackFreight = () => {
    };

    const RowListData = (data = []) =>
        data.map(item => {
            const { label, color } = getStatusStyle(item?.status);
            return {
                _id: item._id,
                original: item,
                serial: <>
                    <div className="signDropdown">
                        <button className="dropbtn11" onClick={(e) => e.stopPropagation()}>
                            <BsThreeDotsVertical />
                        </button>
                       {item?.status !="Cancelled" && <div className="dropdownContent">
                            <div
                                onClick={(e) => {
                                    e.stopPropagation(); // ✅ row click rokta hai
                                    setCancelExpenseOpen({ expense_id: item._id });
                                }}
                                className='_avPointer'
                            >
                                <span className='_samAnchor'>
                                    <span className='deleteIcon_avt'>
                                        <FaRegTrashCan color='red' />
                                    </span>
                                    Cancel
                                </span>
                            </div>
                        </div>}
                    </div>
                </>,
                number: <span>{item.sequence_no || "-"}</span>,
                voucher_date: item.date
                    ? new Date(item.date).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })
                    : "-",
                firm_name: <CustomToolTip>{item?.firm?.firm || "-"}</CustomToolTip>,
                vendor: (
                    <CustomToolTip>
                        <div
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (item?.vendor_detail?.name != "No Vendor") {
                                    navigate(
                                        `/${item.vendor_type === 8 ? `accounting` : `account`}/${constant.tnxName2[constant.tnxName3[item.vendor_type]]}/details/${item?.vendor_detail?._id}?type=${constant.tnxName3[item.vendor_type]}&tab=${1}&search=${item?.vendor_detail?.name}&offset=${1}&total_record=${25}&name=${item?.vendor_detail?.name}&driver_type=${item.vendor_type === 3 ? 1 : ''}&is_list=true`
                                    );
                                }
                            }}
                        >
                            {item?.vendor_detail?.name || "-"}
                        </div>

                        <small className="text-muted" onClick={(e) => {
                            e.stopPropagation();
                            if (item?.vendor_detail?.name != "No Vendor") {
                                navigate(
                                    `/${item.vendor_type === 8 ? `accounting` : `account`}/${constant.tnxName2[constant.tnxName3[item.vendor_type]]}/details/${item?.vendor_detail?._id}?type=${constant.tnxName3[item.vendor_type]}&tab=${1}&search=${item?.vendor_detail?.name}&offset=${1}&total_record=${25}&name=${item?.vendor_detail?.name}&driver_type=${item.vendor_type === 3 ? 1 : ''}&is_list=true`
                                );
                            }
                        }}>
                            {masterData?.vendor_type[item.vendor_type] || ""}
                        </small>
                    </CustomToolTip>
                ),
                total_amt: `₹${(item.total_amount || 0).toLocaleString()}`,
                balance: `₹${(item.due_amount || 0).toLocaleString()}`,
                under_approval: `₹ ${(item.approval_amount || 0).toFixed(2)}`,
                status: <span className="trs-status" style={{ background: color }}>{label}</span>,
                tags: (
                    <div className="d-flex gap-1 flex-wrap">
                        {Object.values(item.tags || {}).map((tag, i) => (
                            <span key={i} className="tag-badge-bx">{tag}</span>
                        ))}
                    </div>
                ),
                action: (
                    <div className="_rSide_drp">
                        <div className="signDropdown">
                            <button className="dropbtn11">
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                    <rect x="0.390625" y="0.390625" width="24.2188" height="24.2188" rx="2.73438" stroke="#0049D7" strokeWidth="0.78125" />
                                    <path d="M12.5 7.8125C13.3629 7.8125 14.0625 7.11295 14.0625 6.25C14.0625 5.38706 13.3629 4.6875 12.5 4.6875C11.6371 4.6875 10.9375 5.38706 10.9375 6.25C10.9375 7.11295 11.6371 7.8125 12.5 7.8125Z" fill="#0049D7" />
                                    <path d="M12.5 14.0625C13.3629 14.0625 14.0625 13.3629 14.0625 12.5C14.0625 11.6371 13.3629 10.9375 12.5 10.9375C11.6371 10.9375 10.9375 11.6371 10.9375 12.5C10.9375 13.3629 11.6371 14.0625 12.5 14.0625Z" fill="#0049D7" />
                                    <path d="M12.5 20.3125C13.3629 20.3125 14.0625 19.6129 14.0625 18.75C14.0625 17.8871 13.3629 17.1875 12.5 17.1875C11.6371 17.1875 10.9375 17.8871 10.9375 18.75C10.9375 19.6129 11.6371 20.3125 12.5 20.3125Z" fill="#0049D7" />
                                </svg>
                            </button>
                            <div className="dropdownContent"></div>
                        </div>
                    </div>
                ),
            };
        });

    const cancelExpenseHandle = async () => {
        setCancelading(true)
        const res = await cancelExpenseApi({
            expense_id: cancleExpenseOpen?.expense_id,
        });

        if (res?.responseCode === 200) {
            setCancelading(false);
            setCancelExpenseOpen(false);
            fetchPaymentTransactions()
            toast.success(res?.responseMessage);
        } else {
            setCancelading(false);
            toast.error(res?.responseMessage);
        }
    }

    const AddExpensesModalProps = {
        isOpen: showExpModal,
        closeModal: handleCloseModal,
        modalMainClass: "_dashCommon_Modal _addExpModal",
        modalTitle: "General Expenses",
        headerPart: false,
        footerPart: true,
        sendApprovalButtonTitle: "Send for Approval",
        submitTitle: "Add General Expense",
        cancelButtonTitle: "Cancel",
        callBackFreight: fetchPaymentTransactions,
    };

    let cancleTripProps = {
        show: cancleExpenseOpen,
        closeModal: (e) => setCancelExpenseOpen(false),
        title: "Cancel Expense",
        submitTitle: "Cancel Expense",
        onSubmit: cancelExpenseHandle,
        isLoadding: cancelLoading,
        disabled: cancelLoading,
    };
    return (
        <div className='trs-exp-table'>
            <BootstrapTable
                tableClass="trs-exp-table-inner"
                columns={columns}
                data={RowListData(paymentTransactionList)}
                onRowClick={(e, row) => handleRowClick(row)}
            />
            <div className='paginationFt_avt'>
                <CustomPagination
                    totalItems={totalRecord}
                    itemsPerPage={itemsPerPage}
                    currentPage={offset}
                    onPageChange={onPageChange}
                />
            </div>

            {showExpModal && <AddExpensesModal {...AddExpensesModalProps} />}
            {cancleExpenseOpen && (
                <ConfirmModalFor {...cancleTripProps}>
                    <>
                        <p className="_confirmPrx">
                            Do you really want Cancel Expense ?
                        </p>
                    </>
                </ConfirmModalFor>
            )}
        </div>
    );
};

export default GenExpListTab;